<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<p class="calibre3"><span class="x-ebookmaker-pageno" id="pgepubid00106" title="[120]"><a id="Page_120"></a></span></p>
<h2 id="ESCAPE_BUT_NOT_ESCAPE">ESCAPE BUT NOT ESCAPE.</h2>
</div>
<div class="blockquot">
<p class="calibre3">MOVED FROM CAMP LAWTON AFTER A SOJOURN OF TWENTY DAYS—DESTINATION
BLACKSHEAR, GA.—JUMP OFF THE CARS AND OUT
FROM REBEL GUARD FOR SIX DAYS—A HUNGRY TIME BUT A GOOD
ONE—CAPTURED AND MAKE THE ACQUAINTANCE OF TWO OTHER
RUNAWAYS WITH WHOM I CAST MY FORTUNES, ETC., ETC.</p>
</div>
<p class="calibre3">Nov. 22.—And now my turn has come, and I get off with the
next load going to-day. My trunk is packed and baggage duly
checked; shall try and get a “lay over” ticket, and rusticate on the
road. Will see the conductor about it. A nice cool day with sun
shining brightly—a fit one for an adventure and I am just the boy
to have one. Coverlid folded up and thrown across my shoulder,
lower end tied as only a soldier knows how. My three large books
of written matter on the inside of my thick rebel jacket, and fastened
in. Have a small book which I keep at hand to write in now.
My old hat has been exchanged for a red zouave cap, and I look
like a red headed woodpecker. Leg behaving beautifully. My
latest comrades are James Ready and Bill Somebody. We have
decided to go and keep together on the cars. One of them has an
apology for a blanket, and the two acting in conjunction keep all
three warm nights. <span class="smcap">Later.</span>—On the cars, in vicinity of Savannah
en-route for Blackshear, which is pretty well south and not far
from the Florida line. Are very crowded in a close box car and
fearfully warm. Try to get away to-night.</p>
<p class="calibre3"><span class="smcap">In the Woods near Doctortown Station, No. 5</span>, Ga., Nov.
23.—A change has come over the spirit of my dreams. During the<span class="x-ebookmaker-pageno" title="[121]"><a id="Page_121"></a></span>
night the cars ran very slow, and sometimes stopped for hours on
side tracks. A very long, tedious night, and all suffered a great
deal with just about standing room only. Impossible to get any
sleep. Two guards at each side door, which were open about a
foot. Guards were passably decent, although strict. Managed to
get near the door, and during the night talked considerable with the
two guards on the south side of the car. At about three o’clock
this <span class="allsmcap">A. M.</span>, and after going over a long bridge which spanned the
Altamaha River and in sight of Doctortown, I went through the
open door like a flash and rolled down a high embankment. Almost
broke my neck, but not quite. Guard fired a shot at me, but
as the cars were going, though not very fast, did not hit me.
Expected the cars to stop but they did not, and I had the inexpressible
joy of seeing them move off out of sight. Then crossed the
railroad track going north, went through a large open field and
gained the woods, and am now sitting on the ground leaning up
against a big pine tree <em>and out from under rebel guard</em>! The sun is
beginning to show itself in the east and it promises to be a fine day.
Hardly know what to do with myself. If those on the train notified
Doctortown people of my escape they will be after me. Think
it was at so early an hour that they might have gone right through
without telling any one of the jump off. Am happy and hungry
and considerably bruised and scratched up from the escape. The
happiness of being here, however, overbalances everything else. If
I had George Hendryx with me now would have a jolly time, and
mean to have as it is. Sun is now up and it is warmer; birds
chippering around, and chipmunks looking at me with curiosity.
Can hear hallooing off a mile or so, which sounds like farmers calling
cattle or hogs or something. All nature smiles—why should
not I?—and I do. Keep my eyes peeled, however, and look all
ways for Sunday. Must work farther back toward what I take to
be a swamp a mile or so away. Am in a rather low country
although apparently a pretty thickly settled one; most too thickly
populated for me, judging from the signs of the times. It’s now
about dinner time, and I have traveled two or three miles from the
railroad track, should judge and am in the edge of a swampy forest,
although the piece of ground on which I have made my bed is
dry and nice. Something to eat wouldn’t be a bad thing. Not
over sixty rods from where I lay is a path evidently travelled more
or less by negroes going from one plantation to another. My hope
of food lays by that road. Am watching for passers by. <span class="smcap">Later.</span>—A<span class="x-ebookmaker-pageno" title="[122]"><a id="Page_122"></a></span>
negro boy too young to trust has gone by singing and whistling,
and carrying a bundle and a tin pail evidently filled with somebody’s
dinner. In as much as I want to enjoy this out-door Gypsy
life, I will not catch and take the dinner away from him. That
would be the height of foolishness. Will lay for the next one
traveling this way. The next one is a dog and he comes up and
looks at me, gives a bark and scuds off. Can’t eat a dog. Don’t
know how it will be to-morrow though. Might be well enough for
him to come around later. Well, it is most dark and will get ready
to try and sleep. Have broken off spruce boughs and made a soft
bed. Have heard my father tell of sleeping on a bed of spruce, and
it is healthy. Will try it. Not a crust to eat since yesterday forenoon.
Am educated to this way of living though, and have been
hungryer. Hope the pesky alligators will let me alone. If they
only knew it, I would make a poor meal for them. Thus closes my
first day of freedom and it is <em>grand</em>. Only hope they may be many,
although I can hardly hope to escape to our lines, not being in a
condition to travel.</p>
<p class="calibre3">Nov. 24.—Another beautiful morning, a repetition of yesterday,
opens up to me. It is particularly necessary that I procure sustenance
wherewith life is prolonged, and will change my head-quarters
to a little nearer civilization. Can hear some one chopping not
a mile away. Here goes. <span class="smcap">Later.</span>—Found an old negro fixing up
a dilapidated post and rail fence. Approached him and enquired
the time of day. (My own watch having run down.) He didn’t happen
to have his gold watch with him, but reckoned it was nigh
time for the horn. Seemed scared at the apparition that appeared
to him, and no wonder. Forgave him on the spot. Thought it
policy to tell him all about who and what I was, and did so. Was
very timid and afraid, but finally said he would divide his dinner
as soon as it should be sent to him, and for an hour I lay off a distance
of twenty rods or so, waiting for that dinner. It finally came,
brought by the same boy I saw go along yesterday. Boy sat down
the pail and the old darkey told him to scamper off home—which
he did. Then we had dinner of rice, cold yams and fried bacon.
It was a glorious repast, and I succeeded in getting quite well
acquainted with him. We are on the Bowden plantation and he
belongs to a family of that name. Is very fearful of helping me
as his master is a strong Secesh., and he says would whip him
within an inch of his life if it was known. Promise him not to be
seen by any one and he has promised to get me something more to<span class="x-ebookmaker-pageno" title="[123]"><a id="Page_123"></a></span>
eat after it gets dark. <span class="smcap">Later.</span>—After my noonday meal went back
toward the low ground and waited for my supper, which came
half an hour ago and it is not yet dark. Had a good supper of
boiled seasoned turnips, corn bread and sour milk, the first milk I
have had in about a year. Begs me to go off in the morning, which
I have promised to do. Says for me to go two or three miles on to
another plantation owned by LeCleye, where there are good negroes
who will feed me. Thanked the old fellow for his kindness. Says
the war is about over and the Yanks expected to free them all soon.
It’s getting pretty dark now, and I go to bed filled to overflowing;
in fact, most too much so.</p>
<p class="calibre3">Nov. 25.—This morning got up cold and stiff; not enough covering.
Pushed off in the direction pointed out by the darkey of yesterday.
Have come in the vicinity of negro shanties and laying in
wait for some good benevolent colored brother. Most too many
dogs yelping around to suit a runaway Yankee. Little nigs and
the canines run together. If I can only attract their attention without
scaring them to death, shall be all right. However, there is
plenty of time, and won’t rush things. Time is not valuable with
me. Will go sure and careful. Don’t appear to be any men folks
around; more or less women of all shades of color. This is evidently
a large plantation; has thirty or forty negro huts in three or
four rows. They are all neat and clean to outward appearances.
In the far distance and toward what I take to be the main road is
the master’s residence. Can just see a part of it. Has a cupola on
top and is an ancient structure. Evidently a nice plantation. Lots
of cactus grows wild all over, and is bad to tramp through. There
is also worlds of palm leaves, such as five cent fans are made of.
Hold on there, two or three negro men are coming from the direction
of the big house to the huts. Don’t look very inviting to
trust your welfare with. Will still wait, McCawber like, for something
to turn up. If they only knew the designs I have on them,
they would turn pale. Shall be ravenous by night and go for them.
I am near a spring of water, and lay down flat and drink. The
“Astor House Mess” is moving around for a change; hope I won’t
make a mess of it. Lot of goats looking at me now, wondering, I
suppose, what it is. Wonder if they butt? Shoo! Going to rain,
and if so I must sleep in one of those shanties. Negroes all washing
up and getting ready to eat, with doors open. No, thank you;
dined yesterday. Am reminded of the song: “What shall we do,
when the war breaks the country up, and scatters us poor darkys<span class="x-ebookmaker-pageno" id="pgepubid00107" title="[124]"><a id="Page_124"></a></span>
all around.” This getting away business is about the best investment
I ever made. Just the friendliest fellow ever was. More than
like a colored man, and will stick closer than a brother if they will
only let me. Laugh when I think of the old darky of yesterday’s
experience, who liked me first rate only wanted me to go away.
Have an eye on an isolated hut that looks friendly. Shall approach
it at dark. People at the hut are a woman and two or three children,
and a jolly looking and acting negro man. Being obliged to
lay low in the shade feel the cold, as it is rather damp and moist.
<span class="smcap">Later.</span>—Am in the hut and have eaten a good supper. Shall sleep
here to-night. The negro man goes early in the morning, together
with all the male darky population, to work on fortifications at
Fort McAllister. Says the whole country is wild at the news of
approaching Yankee army. Negro man named “Sam” and woman
“Sady.” Two or three negroes living here in these huts are not
trustworthy, and I must keep very quiet and not be seen. Children
perfectly awe struck at the sight of a Yankee. Negroes very
kind but afraid. Criminal to assist me. Am five miles from Doctortown.
Plenty of “gubers” and yams. Tell them all about my
imprisonment. Regard the Yankees as their friends. Half a dozen
neighbors come in by invitation, shake hands with me, scrape
the floor with their feet, and rejoice most to death at the good times
coming. “Bress de Lord,” has been repeated hundreds of times in
the two or three hours I have been here. Surely I have fallen
among friends. All the visitors donate of their eatables, and
although enough is before me to feed a dozen men, I give it a tussle.
Thus ends the second day of my freedom, and it is glorious.</p>
<p class="calibre3">Nov. 26.—An hour before daylight “Sam” awoke me and said I
must go with him off a ways to stay through the day. Got up, and
we started. Came about a mile to a safe hiding place, and here I
am. Have plenty to eat and near good water. Sam will tell
another trusty negro of my whereabouts, who will look after me,
as he has to go away to work. The negroes are very kind, and I
evidently am in good hands. Many of those who will not fight in
the Confederate army are hid in these woods and swamps, and
there are many small squads looking them up with dogs and guns
to force them into the rebel ranks. All able-bodied men are conscripted
into the army in the South. It is possible I may be captured
by some of these hunting parties. It is again most night and
have eaten the last of my food. Can hear the baying of hounds<span class="x-ebookmaker-pageno" id="pgepubid00108" title="[125]"><a id="Page_125"></a></span>
and am skeery. Shall take in all the food that comes this way in
the meantime. Sam gave me an old jack knife and I shall make a
good bed to sleep on, and I also have an additional part of a blanket
to keep me warm. In fine spirits and have hopes for the future.
Expect an ambassador from my colored friends a little later.
<span class="smcap">Later.</span>—The ambassador has come and gone in the shape of a woman.
Brought food; a man told her to tell me to go off a distance
of two miles or so, to the locality pointed out, before daylight, and
wait there until called upon to-morrow. Rebel guards occupy the
main roads, and very unsafe.</p>
<p class="calibre3">Nov. 27.—Before daylight came where I now am. Saw alligators—small
ones. This out in the woods life is doing me good.
Main road three miles away, but there are paths running everywhere.
Saw a white man an hour ago. Think he was a skulker
hiding to keep out of the army, but afraid to hail him. Many of
these stay in the woods day-times, and at night go to their homes,
getting food. Am now away quite a distance from any habitation,
and am afraid those who will look for me cannot find me. Occasionally
hear shots fired; this is a dangerous locality. Have now
been out four days and fared splendidly. Have hurt one of my
ankles getting through the brush; sort of sprain, and difficult to
travel at all. No water near by and must move as soon as possible.
Wild hogs roam around through the woods, and can run like a
deer. Palm leaves grow in great abundance, and are handsome to
look at. Some of them very large. Occasionally see lizards and
other reptiles, and am afraid of them. If I was a good traveler I
could get along through the country and possibly to our lines.
Must wander around and do the best I can however. Am armed
with my good stout cane and the knife given me by the negro; have
also some matches, but dare not make a fire lest it attract attention.
Nights have to get up occasionally and stamp around to get warm.
Clear, cool nights and pleasant. Most too light, however, for me
to travel. The remnants of yesterday’s food, have just eaten. Will
now go off in an easterly direction in hopes of seeing the messenger.</p>
<p class="calibre3">Nov. 28.—No one has come to me since day before yesterday.
Watched and moved until most night of yesterday but could see or
hear no one. Afraid I have lost communication. In the distance
can see a habitation and will mog along that way. Most noon.
<span class="smcap">Later.</span>—As I was poking along through some light timber, almost
ran into four Confederates with guns. Lay down close to the<span class="x-ebookmaker-pageno" title="[126]"><a id="Page_126"></a></span>
ground and they passed by me not more than twenty rods away.
Think they have heard of my being in the vicinity and looking me
up. This probably accounts for not receiving any visitor from the
negroes. Getting very hungry, and no water fit to drink. Must
get out of this community as fast as I can. Wish to gracious I
had two good legs. <span class="smcap">Later.</span>—It is now nearly dark and I have
worked my way as near direct north as I know how. Am at least
four miles from where I lay last night. Have seen negroes, and
white men, but did not approach them. Am completely tired out
and hungry, but on the edge of a nice little stream of water. The
closing of the fifth day of my escape. Must speak to somebody to-morrow,
or starve to death. Good deal of yelling in the woods.
Am now in the rear of a hovel which is evidently a negro hut, but
off quite a ways from it. Cleared ground all around the house so
I can’t approach it without being too much in sight. Small negro
boy playing around the house. Too dark to write more.</p>
<p class="calibre3">Nov. 29.—The sixth day of freedom, and a hungry one. Still
where I wrote last night, and watching the house. A woman goes
out and in but cannot tell much about her from this distance. No
men folks around. Two or three negro boys playing about. Must
approach the house, but hate to. <span class="smcap">Noon.</span>—Still right here. Hold
my position. More than hungry. Three days since I have eaten
anything, with the exception of a small potatoe and piece of bread
eaten two days ago and left from the day before. That length of
time would have been nothing in Andersonville, but now being in
better health demand eatables, and it takes right hold of this wandering
sinner. Shall go to the house towards night. A solitary
woman lives there with some children. My ankle from the sprain
and yesterday’s walking is swollen and painful. Bathe it in water,
which does it good. Chickens running around. Have serious meditations
of getting hold of one or two of them after they go to
roost, then go farther back into the wilderness, build a fire with
my matches and cook them. That would be a royal feast. But if
caught at it, it would go harder with me than if caught legitimately.
Presume this is the habitation of some of the skulkers who
return and stay home nights. Believe that chickens squawk when
being taken from the roost. Will give that up and walk boldly up
to the house.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0014.vue?d303de50